import { BackButtonStack } from "lib/app/backButton";
import { useAppUrlOpen } from "lib/app/urlOpen";
import React, { useContext, useMemo, useState } from "react";

const AppContext = React.createContext({
  isApp: null,
  version: null,
  backButtonStack: null,
  deviceToken: null,
  setDeviceToken: null,
});

export const AppProvider = ({ isApp, children }) => {
  const backButtonStack = useMemo(() => {
    return BackButtonStack();
  }, []);

  const [deviceToken, setDeviceToken] = useState(null);

  useAppUrlOpen();

  return (
    <AppContext.Provider
      value={{
        isApp,
        version: 1,
        backButtonStack,
        deviceToken,
        setDeviceToken,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);

export default AppContext;
